import { LocationInfo, LocationGeoType } from '@tt4b/ttam-enums';
import { TranslateResult } from 'vue-i18n';
export interface SelectedListChildrenItem {
  /** 地区全称 */
  name: string;
  /** 唯一 ID */
  id: number;
}
export interface SelectedListItem {
  /** 国家全称 */
  name: string;
  id: number;
  children: SelectedListChildrenItem[];
}

export enum LocationTypeValue {
  CITY = 'city',
  ZIP_CODE = 'zipcode',
}

export enum CurrentLocationStatus {
  INVAILD = 0,
  NOT_SUPPORTED = 1,
  NOT_MATCH = 2,
  VAILD = 3,
  UN_KNOW = 4,
}
export interface UploadLocationsItem {
  // 输入框的唯一id
  inputId: number;
  // vi-input的dom id
  domId: string;
  // 输入的zipcode/location
  value: string;
  status: CurrentLocationStatus;
  // 输入框是否只读
  readonly: boolean;
  // 是否已经校验过
  checked: boolean;
  // 输入框尾部图标
  suffixIcon: string;
  // 校验结果
  isError: boolean;
  // 匹配面板是否可见
  isMatchPanelVisible: boolean;
  // 关键词匹配结果
  matchList: any[];
  // geo定向定向详情
  info?: LocationInfo;
}

export interface BulkUploadFormData {
  locationType: LocationTypeValue;
  country: string;
  locations: UploadLocationsItem[];
}

export interface LocationTypeListInterface {
  label: TranslateResult;
  value: LocationTypeValue;
}
